import { Button, ModalWindow, UIHeading2 } from '@cian/ui-kit';
import * as React from 'react';

import { HeatIndexModalContentContainer } from './containers';
import { useHeatIndex } from './hooks';
import { trackOpenInformer } from './tracking';
import { HeatIndexFooterSection, HeatIndexSection } from '../../components/HeatIndex';

export function HeatIndexContainer() {
  const [open, setOpen] = React.useState(false);
  const heatIndex = useHeatIndex();

  const handleOpen = React.useCallback(() => {
    trackOpenInformer();
    setOpen(true);
  }, []);

  const handleClose = React.useCallback(() => setOpen(false), []);

  if (!heatIndex) {
    return null;
  }

  return (
    <>
      <HeatIndexSection {...heatIndex} onClick={handleOpen} />
      <ModalWindow
        open={open}
        onClose={handleClose}
        fixed={false}
        size="M"
        width={628}
        header={<UIHeading2>Как считается индекс тепла</UIHeading2>}
        content={<HeatIndexModalContentContainer />}
        footer={
          <HeatIndexFooterSection>
            <Button size="XS" data-testid="close-btn" theme="fill_primary" onClick={handleClose}>
              Буду знать!
            </Button>
          </HeatIndexFooterSection>
        }
      />
    </>
  );
}
